import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AbpBase from '@/lib/AbpBase';
import { Component, Prop } from 'vue-property-decorator';
import { UserServiceProxy } from '@/lib/service-proxy/service-proxies';
var SelectUserModal = /** @class */ (function (_super) {
    __extends(SelectUserModal, _super);
    function SelectUserModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.allUsers = [];
        _this.totalCount = 0;
        _this.currentPage = 1;
        _this.searchInput = { filter: '' };
        _this.userService = new UserServiceProxy();
        return _this;
    }
    Object.defineProperty(SelectUserModal.prototype, "userColumns", {
        get: function () {
            var vm = this;
            return [
                { key: 'id', title: 'Id', width: 80, align: 'center' },
                { key: 'userName', title: '用户名', align: 'center' },
                { key: 'name', title: '昵称', align: 'center' },
                { key: 'phoneNumber', title: '手机号', align: 'center' },
                {
                    key: 'actions', title: '操作', width: 100, align: 'center',
                    render: function (h, params) {
                        return h('Button', {
                            props: { size: 'small', type: 'primary' },
                            on: {
                                click: function () {
                                    if (vm.onSelected !== undefined) {
                                        if (vm.businessType) {
                                            params.row.businessType = vm.businessType;
                                        }
                                        vm.onSelected(params.row);
                                    }
                                }
                            }
                        }, '选择');
                    }
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    ;
    SelectUserModal.prototype.created = function () {
        this.getUsers();
    };
    SelectUserModal.prototype.getUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var skip, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        skip = (this.currentPage - 1) * 10;
                        return [4 /*yield*/, this.userService.getUsers(this.searchInput.filter, undefined, undefined, 'name', 10, skip)];
                    case 1:
                        result = _a.sent();
                        this.allUsers = result.items;
                        this.totalCount = result.totalCount;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    SelectUserModal.prototype.pageChange = function (page) {
        this.currentPage = page;
        this.getUsers();
    };
    __decorate([
        Prop({
            type: [Function], default: function () {
            }
        })
    ], SelectUserModal.prototype, "onSelected", void 0);
    __decorate([
        Prop({
            type: String, default: ''
        })
    ], SelectUserModal.prototype, "businessType", void 0);
    SelectUserModal = __decorate([
        Component({
            name: 'SelectUserModal'
        })
    ], SelectUserModal);
    return SelectUserModal;
}(AbpBase));
export default SelectUserModal;
;
